// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Pufb","section":"styles_section__3wmRK","name":"styles_name__2XCoX","link":"styles_link__2OULD","divider":"styles_divider__3Xs4k"};